export default __webpack_public_path__ + "static/media/b864cf39fa612021de4e686428ecff70.svg";